export const hideShapeToolBoxes = () => {
  const toolBoxes = document.querySelectorAll('.shape-tool-box');
  toolBoxes.forEach((toolBox) => toolBox.classList.add('hidden'));
};

export const showShapeToolBoxes = () => {
  const toolBoxes = document.querySelectorAll('.shape-tool-box');
  toolBoxes.forEach((toolBox) => toolBox.classList.remove('hidden'));
};
